import { COLORS, BOX_SHADOWS } from 'constants/index';
import typography from '../typography';

export const MuiTableCell = {
  root: {
    padding: '16px',
    borderBottom: 'none',
    boxShadow: BOX_SHADOWS.divider,
  },
  head: {
    ...typography.body2,
    lineHeight: '24px',
    fontWeight: 500,
    letterSpacing: '.1px',
  },
  body: {
    ...typography.body1,
    backgroundColor: COLORS.WHITE,
    color: COLORS.BLACK_6,
  },
};
